var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StepLayout } from '@/components/step-layout.component';
import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useResultCategoryOutletContext } from '@/components/results-category/hooks/use-result-category-outlet-context.hook';
import { LogoAndHeading } from '@/components/logo-and-heading.component';
import { Button } from '@mui/material';
import { useNavigator } from 'hx-navigator';
import { OverLayBanner } from '@/components/overlay-banner.component';
import { useSelector } from 'react-redux';
import { isResultsCategory } from '@/components/results-category/helpers/is-results-category.helper';
import { ErrorMessage } from '@/components/error-message.component';
import { NavigationButton, NavigationButtonsContainer, } from '@/components/navigation-button.component';
import { EndSessionLink } from '@/components/end-session-link.component';
export default function ResultCategoryPage() {
    var _a = useState(''), image = _a[0], setImage = _a[1];
    var _b = useState(0), setStep = _b[1];
    var navigate = useNavigator().navigate;
    var location = useLocation();
    var category = useSelector(function (state) { return state.dinTest.result.category; });
    if (!category || !isResultsCategory(category)) {
        return (_jsx(ErrorMessage, { action: function () { return navigate('/'); }, actionText: "Retake Test", message: "Oops! Cannot display results" }));
    }
    return (_jsx(StepLayout, { progress: { phase: 2, step: 4 }, heading: _jsx(LogoAndHeading, { image: {
                height: 110,
                width: 118,
            } }), overlayedContent: _jsx(OverLayBanner, { content: _jsx(Button, __assign({ variant: "text", className: "underline underline-offset-2 text-white", onClick: function () {
                    return navigate('/disclaimer', {
                        state: { from: location.pathname },
                    });
                } }, { children: "Disclaimer" })), className: "bg-banner-blue text-center text-xl font-bold text-white py-1" }), image: image, content: _jsx(Outlet, { context: {
                setImage: setImage,
                setStep: setStep,
            } }), nav: _jsxs("div", __assign({ className: 'flex flex-col items-center justify-center py-2' }, { children: [_jsxs(NavigationButtonsContainer, { children: [_jsx(NavigationButton, __assign({ variant: "outlined", navigate: '/hearing-aid-simulator', className: 'text-center' }, { children: "Hearing aid simulator" })), _jsx(Button, __assign({ variant: "contained", href: "https://www.bestbuy.com/site/hearing-aids-amplifiers/hearing-aids/pcmcat1616614505031.c?id=pcmcat1616614505031", target: "_blank", rel: "noreferrer noopener", className: 'sm:w-60 sm:max-w-60 py-3 w-full disabled:bg-primary/40 text-center' }, { children: "Shop for hearing aids" }))] }), _jsx(EndSessionLink, {})] })) }));
}
export function ResultCategoryOutlet() {
    return _jsx(Outlet, { context: useResultCategoryOutletContext() });
}
